import React, { useEffect, useState } from "react";
import { DataSubmissionPageFactory, ScriptHostComponent } from "@eyra/feldspar";
import { ConsentFormVizFactory } from "./factories/consent_form_viz";
import { FileInputMultipleFactory } from "./components/file_input_multiple/factory"
import { ErrorPageFactory } from "./components/error_page/factory"
import { QuestionnaireFactory } from "./components/questionnaire/factory"

function App() {
  const [pidError, setPidError] = useState<string | null>(null);

  useEffect(() => {
    // Check if pid parameter exists in URL
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get('pid');

    if (!pid) {
      setPidError('Missing required parameter: pid');
      return;
    }

    // Optional: Validate pid format (TTK_xxxx_xxxx)
    // Allow both hyphens and underscores for flexibility
    const pidPattern = /^TTK_[a-zA-Z0-9_\-]+$/;
    if (!pidPattern.test(pid)) {
      setPidError(`Invalid pid format. Expected format: TTK_xxxx_xxxx`);
      return;
    }

    setPidError(null);
  }, []);

  // Show error if pid is missing or invalid
  if (pidError) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        padding: '2rem',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <h1 style={{ color: '#d32f2f', marginBottom: '1rem' }}>Access Denied</h1>
        <p style={{ color: '#666', textAlign: 'center', maxWidth: '600px' }}>
          {pidError}
        </p>
        <p style={{ color: '#999', marginTop: '1rem', fontSize: '0.9rem' }}>
          Please ensure you access this page with a valid pid parameter: <code>?pid=TTK_xxxx_xxxx</code>
        </p>
      </div>
    );
  }

  return (
    <div className="App">
      <ScriptHostComponent
        workerUrl="./d3i_py_worker.js"
        standalone={process.env.NODE_ENV !== "production"}
        factories={[
          new DataSubmissionPageFactory({
            promptFactories: [
                new ConsentFormVizFactory(),
                new FileInputMultipleFactory(),
                new ErrorPageFactory(),
                new QuestionnaireFactory(),
            ],
          }),
        ]}
      />
    </div>
  );
}

export default App;
